import { SET_ALL_WAREHOUSES_IN_STORE } from './types';

export const setAllWarehousesInStore = (data) => {
  return {
    type: SET_ALL_WAREHOUSES_IN_STORE,
    data,
  };
};
